module.exports = __webpack_public_path__ + "static/media/logoWhite.2b660b44.svg";